import { useMutation, useQueryClient } from "@tanstack/react-query";
import artistsBriefsClient, { ArtistsBrief } from "../../../api/artists-briefs";

interface UseSaveArtistsBriefsMutationOptions {
  onSuccess?: () => void;
}

export const getSaveBriefsErrorMessage = (error: unknown): string =>
  (error as { response?: { data?: { message?: string } } } | null)?.response
    ?.data?.message || "Failed to save. Please try again.";

const useSaveArtistsBriefsMutation = (
  options?: UseSaveArtistsBriefsMutationOptions,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["artists-briefs"],
    mutationFn: (briefs: ArtistsBrief[]) =>
      artistsBriefsClient.saveBriefs(briefs),
    onSuccess: () => {
      options?.onSuccess?.();
      queryClient.invalidateQueries({ queryKey: ["artists-briefs"] });
    },
  });
};

export default useSaveArtistsBriefsMutation;
